import { Link } from 'react-router-dom';
import { useSeoMeta } from '@unhead/react';
import { Home, Target } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { LoginArea } from '@/components/auth/LoginArea';
import { useCurrentUser } from '@/hooks/useCurrentUser';

export default function LifeGoals() {
  const { user } = useCurrentUser();

  useSeoMeta({ title: 'Life Goals - Zenstr' });

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border/50">
        <div className="container mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="text-2xl">🧘‍♀️</span>
            <span className="font-display font-semibold">Zenstr</span>
          </div>
          <Link to="/">
            <Button variant="ghost" size="sm"><Home className="w-4 h-4 mr-2" /> Dashboard</Button>
          </Link>
        </div>
      </header>

      <main className="container mx-auto px-6 py-16 max-w-3xl">
        <div className="space-y-8">
          <div className="text-center space-y-2">
            <Target className="w-16 h-16 mx-auto text-green-500" />
            <h1 className="text-4xl md:text-5xl font-display font-bold">Life Goals</h1>
            <p className="text-lg text-muted-foreground">Track your dreams</p>
          </div>

          {!user ? (
            <Card className="p-12 text-center space-y-4 bg-card/50">
              <p className="text-muted-foreground">Log in to track goals</p>
              <LoginArea className="max-w-60 mx-auto" />
            </Card>
          ) : (
            <Card className="p-8 bg-card/50">
              <p className="text-center text-muted-foreground">Feature coming soon</p>
            </Card>
          )}
        </div>
      </main>
    </div>
  );
}
